'use strict';

const $headerPopover = $('.cc-header__popover');
let popoverHideTimeout;

$('.js-headerUser').on('mouseenter', function () {
    if (window.isDesktop) {
        clearTimeout(popoverHideTimeout);
        $headerPopover.removeClass('d-none').addClass('show');
        $('body').addClass('cc-popover-is-open');
    }
});

$('.js-headerUser, .cc-header__popover').on('mouseleave', function () {
    if (window.isDesktop) {
        popoverHideTimeout = setTimeout(() => {
            const isHovering = $('.js-headerUser:hover, .cc-header__popover:hover').length > 0;
            const isInputFocused = $(document.activeElement).is('input');

            if (!isHovering && !isInputFocused) {
                $headerPopover.removeClass('show').addClass('d-none');
                $('body').removeClass('cc-popover-is-open');
            }
        }, 250);
    }
});


$headerPopover.on('focusin', 'input', function () {
    clearTimeout(popoverHideTimeout);
    });

$headerPopover.on('blur', 'input', function () {
    setTimeout(() => {
        const isHovering = $('.js-headerUser:hover, .cc-header__popover:hover').length > 0;
        if (!isHovering) {
            $headerPopover.removeClass('show').addClass('d-none');
            $('body').removeClass('cc-popover-is-open');
        }
    }, 250);
});
